import {
    useMemo
} from "react";
import {
    type TextStyle,
    StyleSheet
} from "react-native";
import {
    MOTION_CSS_EASINGS
} from "../../../../helpers/motion";
import {
    webStyle
} from "../../../../utils";

const stylesheet = StyleSheet.create({
    text: {
        flexShrink: 1
    }
});

export const useStyles = ({
    duration,
    from,
    to
}: {
    duration: number;
    from?: string;
    to?: string;
}) => {
    const webBreathe = useMemo(() => StyleSheet.create({
        breathe: webStyle({
            animationTimingFunction: MOTION_CSS_EASINGS.inOut,
            animationIterationCount: "infinite",
            animationKeyframes: {
                "0%, 100%": {
                    color: from
                },
                "50%": {
                    color: to
                }
            }
        })
    }).breathe, [
        from,
        to
    ]);

    const styles = {
        webBreathe: [
            webBreathe,
            webStyle({
                animationDuration: `${duration}ms`
            })
        ] as Array<TextStyle>
    };

    return styles;
};
export default stylesheet;
